import {
  avgDealSizeTable,
  clientUseCases,
  groupSizes,
  winRateTable,
} from '../constants'

export const calculateEnterpriseEstimatedRevenue = (seats, useCase) => {
  const seatsItem = groupSizes.find((item) => item.value === seats)
  const useCaseItem = clientUseCases.find((item) => item.value === useCase)

  if (!seatsItem || !useCaseItem) return null

  const INTERCEPT = -1.882559639
  const GROUP_SIZE_BUCKET_NUMBER_COEFFICIENT = 0.2189375865

  // returns a probability between [0, 1]
  const likelihoodOfOpportunity =
    1 /
    (1 +
      Math.E **
        (-1 *
          (GROUP_SIZE_BUCKET_NUMBER_COEFFICIENT * seatsItem.bucketNum +
            useCaseItem.coefficient +
            INTERCEPT)))

  const winRate = winRateTable[seatsItem.tableRow][useCaseItem.tableCol]
  const avgDealSize = avgDealSizeTable[seatsItem.tableRow][useCaseItem.tableCol]
  const salesAmplifier = useCaseItem.salesAmplifier || 1

  // estimated revenue formula
  const revenue =
    likelihoodOfOpportunity * winRate * avgDealSize * salesAmplifier
  return {
    likelihoodOfOpportunity,
    winRate,
    avgDealSize,
    revenue,
  }
}
